import moment from 'moment-timezone'

export const PIN_IN_FIRST_LINE = 3
export const DEFAULT_MIN_PYRAMID_PLINKO_ROWS = 8
export const DEFAULT_MAX_PYRAMID_PLINKO_ROWS = 16

export const DEFAULT_AUTO_BET_COUNTER = 3

export const DEFAULT_BET_AMOUNT = 1

export const DEFAULT_PLINKO_PINS = 8

export const DEFAULT_PLINKO_RISK_LEVEL = 1

export const DEFAULT_PLINKO_AUTO_BETS = 10

export const DEFAULT_NUMBER_OF_BALLS = 1

export const PLINKO_FIXED_ODDS = {
  8: [
    [5.4, 2, 1.6, 0.8, 0.4, 0.8, 1.6, 2, 5.4],
    [13, 3, 1.4, 0.6, 0.4, 0.6, 1.4, 3, 13],
    [29.5, 4, 1.5, 0.3, 0.2, 0.3, 1.5, 4, 29.5]
  ],
  9: [
    [5.5, 2, 1.5, 1.1, 0.4, 0.4, 1.1, 1.5, 2, 5.5],
    [20, 4, 2, 0.7, 0.4, 0.4, 0.7, 2, 4, 20],
    [42, 8, 1.7, 0.5, 0.2, 0.2, 0.5, 1.7, 8, 42]
  ],
  10: [
    [9, 4, 1.3, 1.1, 1, 0.4, 1, 1.1, 1.3, 4, 9],
    [22, 5, 2, 1.4, 0.6, 0.3, 0.6, 1.4, 2, 5, 22],
    [75, 10, 3, 1, 0.5, 0.2, 0.5, 1, 3, 10, 75]
  ],
  11: [
    [9, 3, 2, 1.3, 1, 0.5, 0.5, 1, 1.3, 2, 3, 9],
    [24, 6, 3, 2, 0.6, 0.3, 0.3, 0.6, 2, 3, 6, 24],
    [120, 14, 6, 1.4, 0.3, 0.2, 0.2, 0.3, 1.4, 6, 14, 120]
  ],
  12: [
    [10, 3, 1.5, 1.4, 1.1, 0.9, 0.5, 0.9, 1.1, 1.4, 1.5, 3, 10],
    [33, 11, 4, 2, 1.1, 0.8, 0.3, 0.8, 1.1, 2, 4, 11, 33],
    [170, 24, 8, 2, 0.8, 0.2, 0.2, 0.2, 0.8, 2, 8, 24, 170]
  ],
  13: [
    [8.1, 4, 3, 2, 1.4, 1, 0.6, 0.6, 1, 1.4, 2, 3, 4, 8.1],
    [43, 13, 6, 3, 1.6, 0.8, 0.4, 0.4, 0.8, 1.6, 3, 6, 13, 43],
    [260, 37, 11, 4, 1, 0.5, 0.2, 0.2, 0.5, 1, 4, 11, 37, 260]
  ],
  14: [
    [7.1, 4, 2, 1.5, 1.4, 1.1, 1, 0.4, 1, 1.1, 1.4, 1.5, 2, 4, 7.1],
    [58, 15, 7, 3.5, 2, 1, 0.6, 0.2, 0.6, 1, 2, 3.5, 7, 15, 58],
    [420, 56, 18, 5, 2, 0.5, 0.4, 0.2, 0.4, 0.5, 2, 5, 18, 56, 420]
  ],
  15: [
    [15, 8, 3, 2, 1.5, 1.3, 1, 0.6, 0.6, 1, 1.3, 1.5, 2, 3, 8, 15],
    [88, 18, 11, 5, 3, 1.4, 0.7, 0.4, 0.4, 0.7, 1.4, 3, 5, 11, 18, 88],
    [620, 83, 27, 8, 3, 0.8, 0.5, 0.2, 0.2, 0.5, 0.8, 3, 8, 27, 83, 620]
  ],
  16: [
    [16, 9, 2, 1.5, 1.3, 1.2, 1.1, 1, 0.5, 1, 1.1, 1.2, 1.3, 1.5, 2, 9, 16],
    [110, 41, 10, 5, 3, 1.4, 1, 0.5, 0.3, 0.5, 1, 1.4, 3, 5, 10, 41, 110],
    [1000, 130, 26, 9, 4, 2, 0.5, 0.3, 0.2, 0.3, 0.5, 2, 4, 9, 26, 130, 1000]
  ]
}

export const DEFAULT_PLINKO_LIGHTNING_MODE_BOARD = {
  betMultipliers: [{ position: [7, 8], multiplier: '2x' }, { position: [13, 10], multiplier: '15x' }, { position: [2, 2], multiplier: '40x' }],
  payouts: [1000, 155, 6.28, 1.09, 0.35, 0.16, 0, 0.02, 0, 0.01, 0, 0.07, 0.3, 1.4, 29.3, 157, 1000]
}

export const BOX_COLORS = {
  red: 'red',
  orange: 'orange',
  pink: 'pink',
  purple: 'purple',
  blue: 'blue',
  green: 'green'
}

export const BOX_COLORS_NUMBERS = {
  red: 1,
  orange: 2,
  pink: 3,
  purple: 5,
  blue: 7,
  green: 8
}

export const getColorOfWinBox = (box, totalLines = 8) => {
  const pegsInRows = Array.from({
    length: totalLines
  },
  (_, rowIndex) => rowIndex + PIN_IN_FIRST_LINE)

  let color = `${BOX_COLORS.green}`

  if (box < BOX_COLORS_NUMBERS.red || (box === (pegsInRows[totalLines - 1] - 1 - BOX_COLORS_NUMBERS.red))) {
    color = `${BOX_COLORS.red}`
  } else if (box < BOX_COLORS_NUMBERS.orange || (box === (pegsInRows[totalLines - 1] - 1 - BOX_COLORS_NUMBERS.orange))) {
    color = `${BOX_COLORS.orange}`
  } else if (box < BOX_COLORS_NUMBERS.pink || (box >= (pegsInRows[totalLines - 1] - 1 - BOX_COLORS_NUMBERS.pink))) {
    color = `${BOX_COLORS.pink}`
  } else if (box < BOX_COLORS_NUMBERS.purple || (box >= (pegsInRows[totalLines - 1] - 1 - BOX_COLORS_NUMBERS.purple))) {
    color = `${BOX_COLORS.purple}`
  } else if (box < BOX_COLORS_NUMBERS.blue || (box >= (pegsInRows[totalLines - 1] - 1 - BOX_COLORS_NUMBERS.blue))) {
    color = `${BOX_COLORS.blue}`
  }

  return color
}

export const PYRAMID_PLINKO_GAME_RISK_LEVEL = [
  {
    label: 'Easy',
    value: 1
  },
  {
    label: 'Normal',
    value: 2
  },
  {
    label: 'Hard',
    value: 3
  }
]

export const PLINKO_GAME_RISK_LEVEL_OBJ = {
  1: 'Low',
  2: 'Medium',
  3: 'High'
}

export const formatePlinkoBetHistoryDate = (date) => {
  return moment.tz(date, moment.tz.guess()).format('MMMM D, YYYY(H:mm)')
}
